/*
  Botones de añadir del upsell de cordones en el drawer.
  Custom element a propósito: el drawer se re-renderiza reemplazando el
  innerHTML de #AjaxCartForm y los <script> re-insertados quedan inertes,
  pero los custom elements se vuelven a instanciar en cada inserción.
  Este archivo se carga una vez desde cart-form.liquid.
*/
(() => {
  if (typeof customElements.get('cork-cart-upsell') !== 'undefined') return;

  class CorkCartUpsell extends HTMLElement {

    connectedCallback() {
      if (this.dataset.corkReady === 'true') return;
      this.dataset.corkReady = 'true';

      this.addEventListener('click', async event => {
        const button = event.target.closest('[data-cork-pack-add]');
        if (!button || button.disabled) return;

        button.disabled = true;
        button.classList.add('working');

        const addUrl = ((window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_add_url) || '/cart/add') + '.js';
        try {
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new URLSearchParams({ id: button.dataset.corkPackAdd, quantity: '1' }).toString()
          });
          const result = await response.json();
          if (!response.ok || result.status === 422) {
            throw new Error(result.description || result.message || 'add');
          }
          if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          } else {
            window.location.reload();
          }
        } catch (error) {
          button.disabled = false;
          button.classList.remove('working');
          alert('No se ha podido añadir. Prueba de nuevo.');
        }
      });
    }

  }

  customElements.define('cork-cart-upsell', CorkCartUpsell);
})();
